module.exports = __webpack_public_path__ + "img/architectureImg2.80b2ff4e.jpeg";